import React from 'react'
import PropTypes from 'prop-types'
import LineChart from 'react-chartjs/lib/line'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

import style from '../style'

export const MonthGraph = props => {
  const statsData = props.stats.reduce((arr, item) => {
    const _weekIndex = Math.ceil(new Date(item.date).getDate() / 7) - 1
    const _weekValue = arr[_weekIndex]
      ? arr[_weekIndex] + item.earnings
      : item.earnings

    return [
      ...arr.slice(0, _weekIndex),
      _weekValue,
      ...arr.slice(_weekIndex + 1)
    ]
  }, new Array(5).fill(0))

  const options = {
    scaleShowVerticalLines: false,
    bezierCurve: false,
    offsetGridLines: true,
    showLines: false,
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      enabled: false
    }
  }

  const data = {
    labels: ['week 1', 'week 2', 'week 3', 'week 4', 'week 5'],
    datasets: [
      {
        fillColor: `rgba(169, 69, 69, 0.3)`,
        strokeColor: `#A94545`,
        pointColor: `#A94545`,
        pointStrokeColor: '#fff',
        pointHighlightFill: '#fff',
        pointHighlightStroke: 'rgba(220,220,220,1)',
        data: statsData.map(n => n.toFixed(2))
      }
    ]
  }

  return [
    <h3 key={0} className={css(style.headers.h3)}>
      This month's earnings
    </h3>,
    <Row
      key={1}
      className={`${css(
        style.graph.box,
        style[props.theme.name] ? style[props.theme.name].graph.box : null
      )}`}
    >
      <Col style={{ height: `155px`, width: `200px`, overflow: 'hidden' }}>
        <LineChart key={1} data={data} options={options} />
      </Col>
    </Row>
  ]
}

MonthGraph.propTypes = {
  stats: PropTypes.array.isRequired,
  date: PropTypes.object.isRequired
}

export default MonthGraph



// WEBPACK FOOTER //
// ./src/components/Statistics/partials/MonthGraph.js